module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-44-min.1357bb6b.jpg";